import {
	Advertisement,
	AdvertisementAsset,
	BoxLayoutProperties,
} from '@horasys/bellplus/common/types';
import { Client } from '@horasys/bellplus/common/types';
import { Template } from '@horasys/bellplus/common/types';
import { DeviceType } from '@horasys/bellplus/common/types';
import { getTemplateFromJson } from 'jsonutils/template';
import { handleAddImage } from 'store/reducers/advertisementReducer';
export const getJsonFromAdvertisement = (advertisement: Advertisement) => {
	const assetsList: any = [];
	advertisement.templateAssets.forEach((asset: AdvertisementAsset) => {
		switch (asset.type) {
			case 'image':
				assetsList.push({
					assetId: asset.id,
					type: 'image',
					duration: asset.duration,
					isPrimary: asset.isPrimary,
					templateAssetId: asset.templateAsset?.id,
				});

				break;
			case 'multipleImages':
				asset.children?.forEach((child: AdvertisementAsset) => {
					assetsList.push({
						assetId: child.id,
						type: 'image',
						duration: child.duration,
						isPrimary: asset.isPrimary,
						templateAssetId: asset.templateAsset?.id,
					});
				});

				break;

			case 'video':
				{
					const thumbnailAsset = asset.thumbnailAsset;
					if (thumbnailAsset) {
						assetsList.push({
							assetId: thumbnailAsset.id,
							type: 'thumbnail',
							duration: thumbnailAsset.duration,
							parentAssetId: asset.id,
							templateAssetId: asset.templateAsset?.id,
						});
					}

					const bufferAsset = asset.bufferAsset;

					if (bufferAsset) {
						assetsList.push({
							assetId: bufferAsset.id,
							type: 'buffer',
							duration: bufferAsset.duration,
							parentAssetId: asset.id,
							templateAssetId: asset.templateAsset?.id,
						});
					}

					assetsList.push({
						assetId: asset.id,
						type: 'video',
						duration: asset.duration,
						parentAssetId: 0,
						templateAssetId: asset.templateAsset?.id,
						isPrimary: asset.isPrimary,
					});
				}
				break;
			default:
				break;
		}
	});
	return {
		name: advertisement.name,
		clientId: advertisement.client.id,
		templateId: advertisement.template.id,
		assets: assetsList,
		deviceTypeId: advertisement.deviceType.id,
	};
};

export const getAdvertisementFromJson = (json: any): Advertisement => {
	const advertisement: Advertisement = {} as Advertisement;
	advertisement.templateAssets = [];
	advertisement.client = {} as Client;
	advertisement.template = {} as Template;
	advertisement.client.id = json.clientId;
	advertisement.client.name = json.clientName;
	advertisement.client.companyName = json.clientName;
	advertisement.template = getTemplateFromJson(json.templateResponse);
	advertisement.template.id = json.templateId;
	advertisement.name = json.name;
	advertisement.id = json.id;
	advertisement.duration = parseInt(json.duration);
	advertisement.deviceType = {} as DeviceType;
	advertisement.deviceType.id = json.deviceType.id;
	advertisement.deviceType.deviceType = json.deviceType.deviceType;
	advertisement.deviceType.height = json.deviceType.height;
	advertisement.deviceType.width = json.deviceType.width;

	advertisement.noOfSlotsRequired = json.noOfSlotsRequired;
	advertisement.status = json.status;
	const primaryAsset: AdvertisementAsset = {} as AdvertisementAsset;
	primaryAsset.id = 0;

	const templateAssetParentAdvertisementAssetMap = new Map();

	// create parent advertisement asset
	json.assets.forEach((asset: any) => {
		if (!(asset && asset.templateAsset && asset.templateAsset.type && asset.type))
			return;

		switch (asset.templateAsset.type) {
			case 'video':
				{
					let parentAdvertisementAsset: AdvertisementAsset = {} as AdvertisementAsset;
					if (
						templateAssetParentAdvertisementAssetMap.get(
							asset.templateAsset.id,
						)
					) {
						parentAdvertisementAsset = templateAssetParentAdvertisementAssetMap.get(
							asset.templateAsset.id,
						);
					} else {
						templateAssetParentAdvertisementAssetMap.set(
							asset.templateAsset.id,
							parentAdvertisementAsset,
						);
						advertisement.templateAssets.push(parentAdvertisementAsset);
					}

					switch (asset.type) {
						case 'video':
							parentAdvertisementAsset = updateAdvertisementAssetFrom(
								parentAdvertisementAsset,
								asset,
							);
							break;
						case 'buffer':
							{
								const bufferAsset = createAdvertisementAssetFrom(asset);
								parentAdvertisementAsset.bufferAsset = bufferAsset;
							}
							break;
						case 'thumbnail':
							{
								const thumbnailAsset = createAdvertisementAssetFrom(
									asset,
								);
								parentAdvertisementAsset.thumbnailAsset = thumbnailAsset;
							}
							break;
						default:
							break;
					}
				}

				break;

			case 'image':
				{
					const imageAsset = createAdvertisementAssetFrom(asset);
					advertisement.templateAssets.push(imageAsset);
				}
				break;
			case 'multipleImages':
				{
					let parentAdvertisementAsset: AdvertisementAsset = {} as AdvertisementAsset;
					parentAdvertisementAsset.type = 'multipleImages';
					parentAdvertisementAsset.isPrimary = asset.primary;
					parentAdvertisementAsset.templateAsset = {} as BoxLayoutProperties;
					parentAdvertisementAsset.templateAsset.width =
						asset.templateAsset.width;
					parentAdvertisementAsset.templateAsset.height =
						asset.templateAsset.height;
					parentAdvertisementAsset.templateAsset.id = asset.templateAsset.id;
					const properties = JSON.parse(asset.templateAsset.properties);
					parentAdvertisementAsset.templateAsset.multipleImageCount =
						properties.multipleImages;

					if (
						templateAssetParentAdvertisementAssetMap.get(
							asset.templateAsset.id,
						)
					) {
						parentAdvertisementAsset = templateAssetParentAdvertisementAssetMap.get(
							asset.templateAsset.id,
						);
					} else {
						templateAssetParentAdvertisementAssetMap.set(
							asset.templateAsset.id,
							parentAdvertisementAsset,
						);
						advertisement.templateAssets.push(parentAdvertisementAsset);
					}
					const childrenAsset = createAdvertisementAssetFrom(asset);
					if (!parentAdvertisementAsset.children)
						parentAdvertisementAsset.children = [];
					childrenAsset.type = 'multipleImages';
					childrenAsset.parentAssetId = asset.templateAsset.id;
					parentAdvertisementAsset.children.push(childrenAsset);
				}
				break;
			default:
				return;
		}
	});

	return addImagePlaceholders(advertisement);

};
const addImagePlaceholders = (advertisement: Advertisement) => {
	advertisement.templateAssets.forEach((ele: AdvertisementAsset) => {
		if (ele.type === 'multipleImages') {
			if (
				ele.templateAsset &&
				ele.templateAsset?.multipleImageCount && ele.children
			)
				if (
					ele.templateAsset?.multipleImageCount >
					ele.children.length
				)
					ele = handleAddImage(ele);
		}
	})
	return advertisement;
}

const createAdvertisementAssetFrom = (
	jsonAdvertisementAsset: any,
): AdvertisementAsset => {
	const advAsset: AdvertisementAsset = {} as AdvertisementAsset;
	advAsset.id = jsonAdvertisementAsset.assetId;
	advAsset.url = jsonAdvertisementAsset.url;
	advAsset.type = jsonAdvertisementAsset.type;
	advAsset.originalFileName = jsonAdvertisementAsset.originalFileName;
	advAsset.duration = jsonAdvertisementAsset.duration;
	advAsset.isPrimary = jsonAdvertisementAsset.primary;
	advAsset.parentAssetId = jsonAdvertisementAsset.parentAssetId;
	advAsset.templateAsset = {} as BoxLayoutProperties;
	if (jsonAdvertisementAsset.templateAsset) {
		advAsset.templateAsset.id = jsonAdvertisementAsset.templateAsset.id;
		advAsset.templateAsset.width = jsonAdvertisementAsset.templateAsset.width;
		advAsset.templateAsset.height = jsonAdvertisementAsset.templateAsset.height;
	}
	return advAsset;
};

const updateAdvertisementAssetFrom = (
	advAsset: AdvertisementAsset,
	jsonAdvertisementAsset: any,
): AdvertisementAsset => {
	advAsset.id = jsonAdvertisementAsset.assetId;
	advAsset.url = jsonAdvertisementAsset.url;
	advAsset.type = jsonAdvertisementAsset.type;
	advAsset.originalFileName = jsonAdvertisementAsset.originalFileName;
	advAsset.duration = jsonAdvertisementAsset.duration;
	advAsset.isPrimary = jsonAdvertisementAsset.primary;
	advAsset.templateAsset = {} as BoxLayoutProperties;
	if (jsonAdvertisementAsset.templateAsset) {
		advAsset.templateAsset.id = jsonAdvertisementAsset.templateAsset.id;
		advAsset.templateAsset.width = jsonAdvertisementAsset.templateAsset.width;
		advAsset.templateAsset.height = jsonAdvertisementAsset.templateAsset.height;
		if (
			advAsset.type === 'bufferimage' ||
			advAsset.type === 'thumbnail' ||
			advAsset.type === 'multipleImages'
		)
			advAsset.parentAssetId = advAsset.templateAsset.id;
	}
	return advAsset;
};
